import React, { useState } from "react";

const Tab = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="max-w-7xl mx-auto sm:px-6 py-6 lg:px-8">
      <div className="text-gray-500">
        {React.Children.map(children, (child, index) => (
          <button
            key={index}
            style={styles.button}
            className={`${
              activeIndex === index ? "bg-gray-50" : "bg-gray-200"
            }`}
            onClick={() => setActiveIndex(index)}
          >
            {child.props.label}
          </button>
        ))}
      </div>
      <div>
        {React.Children.map(children, (child, index) =>
          activeIndex === index ? child : null
        )}
      </div>
    </div>
  );
};

export default Tab;

const styles = {
  button: {
    padding: "10px",
    cursor: "pointer",
    border: "none",
    marginRight: "5px",
  },
};
